import {
	AUTH_TOKEN,
	AUTHENTICATED,
	SHOW_AUTH_MESSAGE,
	HIDE_AUTH_MESSAGE,
	SIGNOUT_SUCCESS,
	SIGNUP_SUCCESS,
	SHOW_LOADING,
	SIGNIN_WITH_GOOGLE_AUTHENTICATED,
	SIGNIN_WITH_FACEBOOK_AUTHENTICATED,
	SET_USER,
	SIGNIN_SUCCESS,
	UPDATE_AVATAR
} from '../constants/Auth';

const initState = {
	loading: false,
	message: "",
	showMessage: false,
	redirect: "",
	token: null,
	role: "ROLE_USER",
	roles: [],
	username: "",
	code: "",
	credit: 0,
	avatar: null
};

const auth = (state = initState, action) => {
	switch (action.type) {
		case SET_USER: {
			return {
				...state,
				username: action.user.username,
				role: action.user.role,
				roles: action.user.roles,
				code: action.user.code,
				credit: action.user.credit,
				avatar: action.user.avatar,
				token: action.user.token,
				redirect: action.user.redirect ? action.user.redirect : "/",
				loading: false
			};
		}
		case AUTHENTICATED:
			return {
				...state,
				loading: false,
				redirect: '/app',
				token: action.token
			}
		case SIGNIN_SUCCESS: {
			return {
				...state,
				redirect: "/app",
				message: "",
				showMessage: false,
				loading: false
			};
		}
		case SHOW_AUTH_MESSAGE:
			return {
				...state,
				message: action.message,
				showMessage: true,
				loading: false
			}
		case HIDE_AUTH_MESSAGE:
			return {
				...state,
				message: '',
				showMessage: false,
			}
		case SIGNOUT_SUCCESS: {
			return {
				...state,
				message: "",
				showMessage: false,
				token: null,
				redirect: "/",
				loading: false,
				role: "ROLE_USER",
				roles: [],
				username: "",
				code: "",
			};
		}
		case SIGNUP_SUCCESS: {
			return {
				...state,
				loading: false,
				token: action.token
			}
		}
		case SHOW_LOADING: {
			return {
				...state,
				loading: true
			}
		}
		case SIGNIN_WITH_GOOGLE_AUTHENTICATED: {
			return {
				...state,
				loading: false,
				token: action.token
			}
		}
		case SIGNIN_WITH_FACEBOOK_AUTHENTICATED: {
			return {
				...state,
				loading: false,
				token: action.token
			}
		}
		case UPDATE_AVATAR: {
			return {
				...state,
				avatar: action.avatar
			}
		}
		default:
			return state;
	}
}

export default auth